import styles from "./Header.module.scss"
import Image from "../Image"
import { useState } from "react"
import cx from "classnames"
import Link from "next/link"
import { Menu } from "react-feather"
import { useRouter } from "next/router"
import Head from 'next/head'
import Script from 'next/script'  // Importing next/script

function Header({ data = {}, localization = {}, className }) {
  const router = useRouter()
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false)

  return (
    <>
      {/* GTM Script placed outside <Head> */}
      <Script
        id="google-tag-manager"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-W34DGZM');`,
        }}
      />

      {/* GTM Noscript for when JS is disabled */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-W34DGZM"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>

      <Head>
        {/* Other Head contents, if necessary */}
      </Head>

      <header className={cx(styles.header, className)}>
        <div className={styles.headerInner}>
          <div className={styles.logoWrapper}>
            <Link href={"/"} passHref>
              <a>
                <Image
                  alt={data?.logo?.alt}
                  src={data?.logo?.permalink}
                  width={data?.logo?.width}
                  height={data?.logo?.height}
                />
              </a>
            </Link>
          </div>
          <nav className={cx(styles.navWrapper)}>
            <ul
              className={cx({
                [styles.visible]: mobileMenuVisible,
              })}
            >
              {data?.nav?.map((n, i) => (
                <li
                  className={cx({
                    "!w-fit !ml-auto": mobileMenuVisible && n.isPrimary,
                  })}
                  key={i}
                >
                  <a
                    className={cx({
                      [styles.isPrimary]: n.isPrimary,
                      [styles.active]:
                        n.url === router.asPath ||
                        router.asPath.startsWith(n.url),
                    })}
                    href={n.url}
                  >
                    {n.title}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <div
            className={styles.hamburger}
            onClick={() => setMobileMenuVisible(!mobileMenuVisible)}
          >
            <Menu />
          </div>
        </div>
      </header>
    </>
  )
}

export default Header
